import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import Card from "@material-ui/core/Card";
import CardActions from "@material-ui/core/CardActions";
import CardContent from "@material-ui/core/CardContent";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import { Divider } from "@material-ui/core";
import ExpansionPanel from "@material-ui/core/ExpansionPanel";
import ExpansionPanelSummary from "@material-ui/core/ExpansionPanelSummary";
import ExpansionPanelDetails from "@material-ui/core/ExpansionPanelDetails";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import Markdown from "markdown-to-jsx";
import Link from "@material-ui/core/Link";
/* eslint import/no-webpack-loader-syntax: off */
import EDA from "!raw-loader!./Exercise07/EDA.md";
import Pcbfab from "!raw-loader!./Exercise07/components.md";
import Simulation from "!raw-loader!./Exercise07/Simulation.md";
import Test from "!raw-loader!./Exercise07/Test.md";

const styles = theme => ({
  card: {
    minWidth: 275
  },
  para: {
    fontSize: 16
  },
  imgdiv: {
    textAlign: "center",
    margin: "10px"
  },
  img: {
    borderRadius: "8px",
    border: "1px solid gray",
    maxWidth: "80%"
  },
  bullet: {
    display: "inline-block",
    margin: "0 2px",
    transform: "scale(0.8)"
  },
  title: {
    fontSize: 14
  },
  pos: {
    marginBottom: 12
  },
  root: {
    width: "100%"
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    fontWeight: theme.typography.fontWeightRegular
  }
});

function SimpleCard(props) {
  const { classes } = props;

  const mdconfig = {
    overrides: {
      h1: {
        component: Typography,
        props: {
          variant: "h5",
          color: "primary"
        }
      },
      h2: {
        component: Typography,
        props: {
          variant: "h5",
          color: "secondary"
        }
      },
      h3: {
        component: Typography,
        props: {
          variant: "h6",
          color: "textSecondary",
          className: classes.para
        }
      },
      a: {
        component: Link,
        props: {
          target: "_blank"
        }
      },
      p: {
        component: Typography,
        props: {
          paragraph: true,
          className: classes.para
        }
      },
      ul: {
        component: Typography,
        props: {
          component: "ul",
          className: classes.para
        }
      },
      em: {
        props: {
          className: classes.para
        }
      },
      pre: {
        props: {
          // className: "w3-panel w3-card w3-light-grey"
          className: "w3-card "
        }
      },
      code: {
        props: {
          className: "w3-code jsHigh notranslate"
        }
      }
    }
  };

  return (
    <div>
      <Card className={classes.card}>
        <CardContent>
          <Typography
            className={classes.title}
            color="textSecondary"
            gutterBottom
          >
            Jan 16, 2019
          </Typography>
          <Typography variant="h5" component="h2">
            Electronics Design
          </Typography>
          <Typography className={classes.pos} color="textSecondary">
            components, circuits, EDA, test equipment
          </Typography>
          <Typography component="p">
            group project:
            <br />
            {
              '"use the test equipment in your lab to observe the operation of a microcontroller circuit board"'
            }
            <br />
            individual project:
            <br />
            {'"redraw the echo hello-world board"'}
            <br />
            {
              '"add (at least) a button and LED (with current-limiting resistor)"'
            }
            <br />
            {'"check the design rules, make it, and test it"'}
            <br />
            {'"extra credit: simulate its operation"'}
            <br />
          </Typography>
        </CardContent>
        <CardActions>
          <Button
            href="http://academy.cba.mit.edu/classes/electronics_design/index.html"
            target="_blank"
            size="small"
          >
            Learn More
          </Button>
        </CardActions>
        <Divider />
      </Card>
      <br />
      <div className={classes.root}>
        <ExpansionPanel>
          <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
            <Typography className={classes.heading}>
              Circuit Components
            </Typography>
          </ExpansionPanelSummary>
          <ExpansionPanelDetails>
            <Markdown options={mdconfig}>{Pcbfab}</Markdown>
          </ExpansionPanelDetails>
        </ExpansionPanel>
        <ExpansionPanel>
          <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
            <Typography className={classes.heading}>
              Electronic design automation - EDA
            </Typography>
          </ExpansionPanelSummary>
          <ExpansionPanelDetails>
            <Markdown options={mdconfig}>{EDA}</Markdown>
          </ExpansionPanelDetails>
        </ExpansionPanel>
        <ExpansionPanel>
          <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
            <Typography className={classes.heading}>Simulation</Typography>
          </ExpansionPanelSummary>
          <ExpansionPanelDetails>
            <Markdown options={mdconfig}>{Simulation}</Markdown>
          </ExpansionPanelDetails>
        </ExpansionPanel>
        <ExpansionPanel>
          <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
            <Typography className={classes.heading}>Test Equipments</Typography>
          </ExpansionPanelSummary>
          <ExpansionPanelDetails>
            <Markdown options={mdconfig}>{Test}</Markdown>
          </ExpansionPanelDetails>
        </ExpansionPanel>
      </div>
    </div>
  );
}

SimpleCard.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(SimpleCard);
